// extracted by mini-css-extract-plugin
export default {"contentText":"PopUpAlertBox_contentText__r5V3+"};